(function ($) {
  "use strict";
  $(function () {
    $(".hamburger").on("click", function () {
      $(".mobile-menu").toggleClass("show");
      $("body").toggleClass("mobile-menu-opened");
      $("html").toggleClass("mobile-menu-opened");
      $(this).toggleClass("is-active");
      $(".header").toggleClass("mobil-header");
    });
  });
})(jQuery);
